module.exports = __webpack_public_path__ + "img/avatar01.0804b371.jpg";